var _path, _setting;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckValidationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vector(Stroke)",
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxWidth: "100%",
      maxHeight: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3803 14.86C58.6948 11.4356 50.1082 10.5872 41.9012 12.4415C33.6942 14.2957 26.3064 18.7533 20.8397 25.1493C15.373 31.5453 12.1203 39.5371 11.5667 47.9328C11.0131 56.3284 13.1883 64.6781 17.7678 71.7366C22.3473 78.795 29.0858 84.1841 36.9782 87.0999C44.8707 90.0158 53.4943 90.3023 61.5629 87.9166C69.6315 85.531 76.7128 80.6011 81.7507 73.8621C86.7885 67.1231 89.513 58.9362 89.5179 50.5223V46.5449C89.5179 44.2026 91.4166 42.3039 93.7589 42.3039C96.1012 42.3039 98 44.2026 98 46.5449V50.5272C97.9941 60.7702 94.6773 70.7369 88.5443 78.9408C82.4113 87.1448 73.7906 93.1464 63.9679 96.0507C54.1453 98.9549 43.647 98.6062 34.0387 95.0564C24.4305 91.5067 16.2271 84.9461 10.6521 76.3532C5.07701 67.7603 2.42901 57.5955 3.10296 47.3747C3.77692 37.1539 7.73673 27.4247 14.3918 19.6383C21.0469 11.8518 30.0407 6.42525 40.0319 4.16788C50.0231 1.91051 60.4763 2.94329 69.8325 7.11219C71.972 8.0655 72.9336 10.5727 71.9803 12.7122C71.027 14.8517 68.5198 15.8133 66.3803 14.86ZM96.7217 12.6886C98.3976 14.3249 98.4298 17.01 96.7935 18.686L53.7303 62.7931C52.9325 63.6103 51.8388 64.0711 50.6968 64.0714C49.5548 64.0717 48.4609 63.6114 47.6626 62.7946L34.7437 49.5757C33.1066 47.9006 33.1374 45.2155 34.8125 43.5783C36.4876 41.9412 39.1728 41.972 40.8099 43.6472L50.6942 53.761L90.7243 12.7605C92.3606 11.0845 95.0457 11.0523 96.7217 12.6886Z",
    stroke: "#39C38D",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0,0,663.5151977539062"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 1,
    dur: "4.166666666666667s",
    values: "0,0,0,663.5151977539062;     0,331.7575988769531,331.7575988769531,0;     663.5151977539062,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  }))), _setting || (_setting = /*#__PURE__*/React.createElement("setting", null, "\n\t\t{\"type\":\"direct\",\"speed\":12,\"random\":1,\"shift\":1,\"size\":1,\"rupture\":50}\n\t")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckValidationIcon);
export default __webpack_public_path__ + "static/media/CheckValidationIcon.732668c120d869f4d714f5edca0afa34.svg";
export { ForwardRef as ReactComponent };